<script>
  import AmpelBoxVersionEins from '../AmpelBoxVersionEins.svelte';
  import LineBarMixedChartTwoYAxis from '../LineBarMixedChartTwoYAxis.svelte';
  import LineBarMixedChart from '../LineBarMixedChart.svelte';
  import {
    average_month_data,
    average_month_data_only_visible_months,
    create_target_line,
    divide_by,
    get_labels,
    transform_month_data_average,
  } from '../SixModulesUtils.svelte';
  import { dict_to_average } from '../UtilsBalkenProgress.svelte';
  import { object_values } from '../Utils.svelte';

  export let cac_full_year;
  export let redraw;
  export let year = 2090;
  export let target_start = 10;
  export let target_end = 60;
  export let conversion_rate_target = 15;
  export let coc_target = 40;
  export let include_vorjahr;

  export let cac_quaterly_data;
  export let cac_quaterly_data_previous_year;
  export let cac_bianual_data;
  export let cac_bianual_data_previous_year;

  export let conversion_rate_month_data = {
    '2020-01': 20,
    '2020-02': 35,
    '2020-03': 40,
    '2020-04': 50,
    '2020-05': 70,
    '2020-06': 75,
    '2020-07': 40,
    '2020-08': 10,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };

  export let conversion_rate_new_attempt = [10, 12, 13, 14];
  export let conversion_rate_new_attempt_vorjahr = [7, 8, 9, 4];

  export let conversion_rate_full_year = 0;

  export let cac_month_data = {
    '2020-01': 20,
    '2020-02': 35,
    '2020-03': 40,
    '2020-04': 50,
    '2020-05': 70,
    '2020-06': 75,
    '2020-07': 40,
    '2020-08': 10,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };

  //TODO Letzter Eintrag in Array entfernen wenn er Null ist(?)

  export let cac_month_data_vorjahr = {
    '2020-01': 10,
    '2020-02': 15,
    '2020-03': 10,
    '2020-04': 15,
    '2020-05': 10,
    '2020-06': 10,
    '2020-07': 20,
    '2020-08': 10,
    // '2020-09': 10,
    // '2020-10': 10,
    // '2020-11': 10,
  };

  export let time_modus = 'monthly';

  let data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr'],
    datasets: [
      {
        label: 'Dataset 1',
        data: [0, 0, 0, 0],
        type: 'line',
        borderColor: '#4eb3cf',
        pointRadius: 0,
      },
    ],
  };

  let data1 = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr'],
    datasets: [
      {
        label: 'Dataset 1',
        data: [0, 0, 0, 0],
        type: 'line',
        borderColor: '#4eb3cf',
        pointRadius: 0,
      },
    ],
  };

  let data2 = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr'],
    datasets: [
      {
        label: 'Dataset 1',
        data: [0, 0, 0, 0],
        type: 'line',
        borderColor: '#4eb3cf',
        pointRadius: 0,
      },
    ],
  };

  $: {
    target_start, target_end, conversion_rate_month_data, time_modus, include_vorjahr;
    if (conversion_rate_month_data && time_modus) {
      if (time_modus == 'monthly') {
        data = {
          labels: get_labels(year, time_modus),
          datasets: [
            {
              label: 'Conversion Rate Target',
              data: divide_by(
                create_target_line(time_modus, conversion_rate_month_data, conversion_rate_target, conversion_rate_target),
                12
              ),
              type: 'line',
              borderColor: '#00B0F0',
              pointRadius: 0,
              yAxisID: 'y',
            },
            {
              label: 'Conversion Rate',
              data: conversion_rate_new_attempt,
              type: 'line',
              borderColor: '#455f51',
              pointRadius: 3,
              pointStyle: 'rectRot',
              yAxisID: 'y',
            },
            {
              label: 'Conversion Rate Average',
              data: average_month_data_only_visible_months(conversion_rate_new_attempt),
              type: 'line',
              borderColor: '#455f51',
              pointRadius: 0,
              yAxisID: 'y',
              borderDash: [3, 3],
            },
            include_vorjahr
              ? {
                  label: 'Conversion Rate previous year',
                  data: transform_month_data_average(conversion_rate_new_attempt_vorjahr, time_modus),
                  type: 'line',
                  borderColor: '#D9D9D9',
                  pointRadius: 0,
                  yAxisID: 'y',
                }
              : {},
            include_vorjahr
              ? {
                  label: 'Conversion Rate Average previous year',
                  data: average_month_data(conversion_rate_new_attempt_vorjahr, time_modus),
                  type: 'line',
                  borderColor: '#D9D9D9',
                  pointRadius: 0,
                  yAxisID: 'y',
                  borderDash: [3, 3],
                }
              : {},

            include_vorjahr
              ? {
                  label: 'Cow Acq. Cost previous year',
                  data: transform_month_data_average(object_values(cac_month_data_vorjahr), time_modus),
                  type: 'bar',
                  borderColor: '#d9d9d9',
                  pointRadius: 0,
                  yAxisID: 'y1',
                }
              : {},
            {
              label: 'Cow Acq. Cost',
              data: transform_month_data_average(object_values(cac_month_data), time_modus),
              type: 'bar',
              borderColor: '#afc5b9',
              pointRadius: 0,
              yAxisID: 'y1',
            },
          ],
        };
      }
      if (time_modus == 'quaterly' || time_modus == 'biannual') {
        data1 = {
          labels: get_labels(year, time_modus),
          datasets: [
            {
              label: 'Conversion Rate Target',
              data: divide_by(
                create_target_line(time_modus, conversion_rate_month_data, conversion_rate_target, conversion_rate_target),
                time_modus == 'quaterly' ? 4 : 2
              ),
              type: 'line',
              borderColor: '#00B0F0',
              pointRadius: time_modus != 'biannual' ? 0 : 5,
              pointStyle: time_modus != 'biannual' ? 'circle' : 'triangle',
              yAxisID: 'y',
            },

            {
              label: 'Conversion Rate Average',
              data: average_month_data_only_visible_months(conversion_rate_new_attempt),
              type: 'line',
              borderColor: '#455f51',
              pointRadius: 0,
              yAxisID: 'y',
              borderDash: [3, 3],
            },
            include_vorjahr
              ? {
                  label: 'Conversion Rate previous year',
                  data: conversion_rate_new_attempt_vorjahr,
                  type: 'bar',
                  borderColor: '#D9D9D9',
                  pointRadius: 0,
                }
              : {},
            include_vorjahr
              ? {
                  label: 'Conversion Rate Average previous year',
                  data: average_month_data(conversion_rate_new_attempt),
                  type: 'line',
                  borderColor: '#D9D9D9',
                  pointRadius: 0,

                  borderDash: [3, 3],
                }
              : {},
            {
              label: 'Conversion Rate',
              data: conversion_rate_new_attempt,
              type: 'bar',
              borderColor: '#455f51',
              pointRadius: 0,
              yAxisID: 'y',
            },
          ],
        };
        data2 = {
          labels: get_labels(year, time_modus),
          datasets: [
            {
              label: 'Cow Acq. Cost Target',
              data: create_target_line(time_modus, cac_month_data_vorjahr, coc_target, coc_target),
              type: 'line',
              borderColor: '#00B0F0',
              pointRadius: time_modus != 'biannual' ? 0 : 5,
              pointStyle: time_modus != 'biannual' ? 'circle' : 'triangle',
              yAxisID: 'y',
            },
            {
              label: 'Cow Acq. Cost Average',
              data: average_month_data(transform_month_data_average(object_values(cac_month_data), time_modus)),
              type: 'line',
              borderColor: '#afc5b9',
              pointRadius: 0,
              yAxisID: 'y',
              borderDash: [3, 3],
            },

            include_vorjahr
              ? {
                  label: 'Cow Acq. Cost previous year',
                  data: time_modus == 'quaterly' ? cac_quaterly_data_previous_year : cac_bianual_data_previous_year,
                  type: 'bar',
                  borderColor: '#d9d9d9',
                  pointRadius: 0,
                }
              : {},
            include_vorjahr
              ? {
                  label: 'Cow Acq. Cost Average previous year',
                  data: average_month_data(transform_month_data_average(object_values(cac_month_data_vorjahr), time_modus)),
                  type: 'line',
                  borderColor: '#D9D9D9',
                  pointRadius: 0,

                  borderDash: [3, 3],
                }
              : {},
            {
              label: 'Cow Acq. Cost',
              data: time_modus == 'quaterly' ? cac_quaterly_data : cac_bianual_data,
              type: 'bar',
              borderColor: '#afc5b9',
              pointRadius: 0,
            },
          ],
        };
      }

      redraw = false;
      redraw = true;
    }
  }
</script>

<div class="row">
  <div class="col" style="padding-right: 0px;">
    <AmpelBoxVersionEins
      target={conversion_rate_target / (year != new Date().getFullYear() ? 1 : 12)}
      current_target={conversion_rate_target / (year != new Date().getFullYear() ? 1 : 12)}
      current={year != new Date().getFullYear()
        ? conversion_rate_full_year
        : dict_to_average(average_month_data(object_values(conversion_rate_month_data)))}
      unterer_text={'Conversion rate ' + (year == new Date().getFullYear() ? ' YTD' : ' p.a.')}
      circle_size={20}
      add_percentage_at_target={true}
      image={time_modus == 'biannual' ? '5_HY_value.png' : '7_Monthly value line.png'}
      image_height={8}
      bottom={10}
    />
  </div>
  <div class="col">
    <AmpelBoxVersionEins
      target={coc_target}
      current_target={coc_target}
      current={cac_full_year}
      unterer_text={'Cow Acq. Cost ' + (year == new Date().getFullYear() ? ' YTD' : ' p.a.')}
      circle_size={20}
      do_not_format={true}
      add_euro_at_target={true}
      image={'10_Cow Acquisition cost pm stack.png'}
      image_height={18}
      bottom={0}
      target_muss_darunter_sein={true}
    />
  </div>
  <div class="col" style="padding-left: 0px;">
    <AmpelBoxVersionEins
      target={coc_target}
      current_target={coc_target}
      current={cac_full_year}
      unterer_text={'Cow Acq. Cost ' + (year == new Date().getFullYear() ? ' YTD' : ' p.a.')}
      circle_size={20}
      do_not_format={true}
      add_euro_at_target={true}
      image={'10_Cow Acquisition cost pm stack.png'}
      image_height={18}
      bottom={0}
      target_muss_darunter_sein={true}
    />
  </div>
</div>
<div class="row" style="width:100%; margin: 0px; height:60%;">
  {#if time_modus == 'monthly'}
    <div class="col" style="max-width:10px!important;"><div class="vertical-center rotate" /></div>
    <div class="col" style="margin:0px; padding:0px; height:0px;">
      <LineBarMixedChartTwoYAxis
        id={Math.floor(Math.random() * 1000000)}
        line_data={data}
        barPercentage={0.9}
        categoryPercentage={time_modus == 'monthly' ? 0.9 : 0.3}
        type={'bar'}
        bind:redraw
        k={true}
        percentage_first_axis={true}
        nachkommastellen={2}
        add_zeichen_1={'% p.m.'}
        add_zeichen_2={'€'}
      />
    </div>
  {/if}
  {#if time_modus == 'quaterly' || time_modus == 'biannual'}
    <div class="col-6" style="margin:0px; padding:0px; height:{chart_hoehe_2}px;">
      <LineBarMixedChart
        id={Math.floor(Math.random() * 1000000)}
        line_data={data1}
        barPercentage={0.9}
        categoryPercentage={0.7}
        type={'bar'}
        percentage_first_axis={true}
        bind:redraw
        add_zeichen_1={'% ' + (time_modus == 'quaterly' ? 'p.q.' : 'p. half-year')}
        nachkommastellen={2}
      />
    </div>
    <div class="col-6" style="margin:0px; padding:0px;  height:{chart_hoehe_2}px;">
      <LineBarMixedChart
        id={Math.floor(Math.random() * 1000000)}
        line_data={data2}
        barPercentage={0.9}
        categoryPercentage={0.7}
        type={'bar'}
        bind:redraw
        k={false}
        nachkommastellen={2}
        add_zeichen_1={'€'}
      />
    </div>
  {/if}
</div>

<style>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .rotate {
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }
</style>
